<template>
    <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="账号类型：">
            <el-radio-group v-model="account_type">
                <el-radio :label="1">旺旺号</el-radio>
                <el-radio :label="2">买家ID</el-radio>
            </el-radio-group>
        </el-form-item>

        <p class="marginT-10">1、建议下载模板填写导入，点击<a class="fc-blue" :href="account_type == 1 ? wangFileLink : uidFileLink" target="_blank"> {{ linkLabel }}</a></p>
        <p class="marginT-10">2、EXCEL请包含：{{ "“" + accountLabel + "”" }}、“打标词”、“打标商品链接”</p>
        <p class="marginT-10">3、请务必按照表格进行上传数据，否则系统无法识别，<span @click="handleImport" class="fc-blue point">导入表格</span></p>
        <el-form-item style="display: none;" label="上传表格：">
            <input type="file" ref="upload" accept=".xls,.xlsx" @change="readExcel" class="outputlist_upload">
        </el-form-item>
        <el-input class="marginT-20" type="textarea" :rows="10" v-model="reXlsxData" readonly></el-input>
        <p class="fc-theme marginT-20" v-if="$store.state.phone">有效数据{{ xlsxData.length }}条，预计消费{{ userData.is_vip ? pricePreMonth.vip_point * (xlsxData.length - pricePreMonth.surplus_given_num >= 0 ? xlsxData.length - pricePreMonth.surplus_given_num : 0) : pricePreMonth.point * (xlsxData.length - pricePreMonth.surplus_given_num >= 0 ? xlsxData.length - pricePreMonth.surplus_given_num : 0) }}点券</p>
        <el-form-item class="marginT-50">
            <el-button type="danger" @click="onSubmit">立即打标</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import XLSX from 'xlsx'

export default {
    props: {
        pricePreMonth: {
            type: Object,
            default() {
                return {}
            }
        },
        userData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            wangFileLink: "http://static.vv-tool.com/%E8%A1%A8%E6%A0%BC%E6%89%B9%E9%87%8F%E6%89%93%E6%A0%87.xlsx",
            uidFileLink: "http://static.vv-tool.com/%E8%A1%A8%E6%A0%BC%E6%89%B9%E9%87%8F%E6%89%93%E6%A0%87%E4%B9%B0%E5%AE%B6ID.xlsx",
            account_type: 1,
            xlsxData: [],
            reXlsxData: undefined
        }
    },
    methods: {
        getQueryVariable(url, variable) {
            var query = url.search.substring(1)
            var vars = query.split('&')
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=')
                if (pair[0] == variable) {
                    return pair[1]
                }
            }
            return (false)
        },
        handleImport() {
            this.$refs.upload.click()
        },
        readExcel(e) {
            let that = this
            const files = e.target.files
            if (files.length <= 0) {
                return false
            } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
                this.$message.error('上传格式不正确，请上传xls或者xlsx格式')
                return false
            }

            const accountKey = this.account_type == 1 ? '打标旺旺' : '买家ID'
            const fileReader = new FileReader()
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result
                    const workBook = XLSX.read(data, {
                        type: 'binary'
                    })
                    const firstSheet = workBook.SheetNames[0]  //取第一张表
                    const ws = XLSX.utils.sheet_to_json(workBook.Sheets[firstSheet])    //生成json表格内容

                    console.log('[ws] = ')
                    console.log(ws)

                    that.xlsxData = []
                    for (let i = 0; i < ws.length; i++) {
                        if (i == 800) {
                            break
                        }

                        const sheetData = {
                            task_sn: i,
                            account: ws[i][accountKey],
                            tag: ws[i]['打标词'],
                        }
                        const pro_url = new URL(ws[i]['打标商品链接'])
                        sheetData.url = this.getQueryVariable(pro_url, 'id')

                        that.xlsxData.push(sheetData)
                    }
                    this.subAlert()
                    this.$refs.upload.value = ''
                } catch (e) {
                    console.log('exception')
                    console.log(e)
                    this.subAlert()
                    this.$refs.upload.value = ''
                    return false
                }

            }
            fileReader.readAsBinaryString(files[0])
        },
        subAlert() {
            this.$alert(`成功识别有效数据${this.xlsxData.length}行，</br>请务必按照模板表格进行上传数据，</br>以便系统识别`, '导入表格成功', {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString: true,
                center: true
            })
        },
        async onSubmit() {
            const that = this;
            let paramsArr = this.xlsxData.map(item => {
                const accountPrefix = that.account_type == 1 ? '' : '||';
                item.task_type = that.account_type == 1 ? 1 : 999;
                item.account = accountPrefix + item.account;
                delete item.task_sn;
                return item
            })

            this.$emit('submit', paramsArr)
        }
    },
    watch: {
        xlsxData(newValue, oldValue) {
            let cacheData = ''
            for (const i in newValue) {
                cacheData += (`${newValue[i].account}，${newValue[i].tag}，${newValue[i].url}\n`)
            }
            this.reXlsxData = cacheData
        }
    },
    computed: {
        accountLabel (){
            return this.account_type == 1 ? '旺旺号' : '买家ID';
        },
        linkLabel (){
            return this.account_type == 1 ? '下载旺旺号模板' : '下载买家id模板';
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
